import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { switchMap, filter, take, catchError } from 'rxjs/operators';
import { OAuthService } from '@app/auth/oauth.service';
import { AuthStatus, AuthState } from '@app/auth/auth.state';
import { env } from '@envs/env';
import * as i0 from "@angular/core";
import * as i1 from "../auth/oauth.service";
import * as i2 from "../auth/auth.state";
var FlumeApiInterceptor = /** @class */ (function () {
    function FlumeApiInterceptor(oauthService, authState) {
        this.oauthService = oauthService;
        this.authState = authState;
        this.absUrlTest = new RegExp('^(?:[a-z]+:)?//', 'i');
        this.exceptions = ['/oauth/token'];
    }
    FlumeApiInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        req = this.addBaseUrl(req);
        // Add access token to the headers
        req = this.addAuthenticationToken(req);
        req = req.clone({
            headers: req.headers
                .set('Cache-Control', 'no-cache')
                .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
                .set('If-Modified-Since', '0'),
        });
        return next.handle(req).pipe(catchError(function (error) {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                return _this.oauthService.authEvents$.pipe(filter(function (state) { return state === AuthStatus.AUTH_VALID; }), take(1), switchMap(function () {
                    req = _this.addBaseUrl(req);
                    return next.handle(_this.addAuthenticationToken(req));
                }));
            }
            if (error instanceof HttpErrorResponse && error.status === 403) {
                _this.oauthService.clearTokens();
            }
            return throwError(error);
        }));
    };
    FlumeApiInterceptor.prototype.addBaseUrl = function (req) {
        if (!this.absUrlTest.test(req.url)) {
            req = req.clone({ url: "" + env.apiUrl + req.url });
        }
        return req;
    };
    FlumeApiInterceptor.prototype.addAuthenticationToken = function (request) {
        var token = this.oauthService.getAccessToken();
        if (!token) {
            return request;
        }
        if (!request.url.includes(env.apiUrl) || request.url.includes('/oauth/token')) {
            return request;
        }
        return request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + token),
        });
    };
    FlumeApiInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FlumeApiInterceptor_Factory() { return new FlumeApiInterceptor(i0.ɵɵinject(i1.OAuthService), i0.ɵɵinject(i2.AuthState)); }, token: FlumeApiInterceptor, providedIn: "root" });
    return FlumeApiInterceptor;
}());
export { FlumeApiInterceptor };
